import FaqSection from '../../containers/PageBuilder/CustomSections/FaqSection';

export default FaqSection;
export { FAQ_CATEGORIES } from '../../containers/PageBuilder/CustomSections/FaqSection';
